export const RouteGroups = {
    MANAGEMENT: 'Management',
    PREFERENCES: 'Preferences',
};

export const URLS = {
    ADMIN: {
        ROOT: '/',
        HOME: '/home',
        AUTH: '/auth',
        MANAGEMENT: '/management',
        BRANCH: '/branch',
        BUILDING: '/building',
        BUILDING_VIEW: '/building-view',
        FLOOR: '/floor',
        FLOOR_PLAN: '/floor-plan',
        OFFICE: '/office',
        NOTIFICATIONS: '/notifications',
        MEETING_ROOM: '/meeting-room',
        CO_WORKING: '/co-working',
        SEAT: '/seat',
        LEAD: '/lead',
        CUSTOMER: '/customer',
        CONTRACTS: '/contracts',
        BOOKING: '/booking',
        USER: '/user',
        USER_GROUPS: '/user-groups',
        SUPPORT: '/support',
        SETTINGS: '/settings',
    },
    CUSTOMER: {
        HOME: '/c/home',
        PROFILE: '/c/profile',
        MEETING_ROOM: '/c/meeting-room',
        CONTRACT: '/c/contract',
        SUPPORT: '/c/support',
    },
    TEAM_MEMBER: {
        HOME: '/tm/home',
        MEETING_ROOM: '/tm/meeting-room',
        SUPPORT: '/tm/support',
        SETTINGS: '/tm/settings',
    },
    RECEPTIONIST: {
        HOME: '/r/home',
        MEETING_ROOM: '/r/meeting-room',
        NOTIFICATIONS: '/r/notifications',
        PROFILE: '/r/profile',
        SUPPORT: '/r/support',
        SETTINGS: '/r/settings',
    },
};
